import { Tabs } from 'antd'
import { useSearchParams } from 'react-router-dom'
import { usePermission } from '@/hooks/usePermission'
import { SchedeLavoro } from './SchedeLavoro'
import LavoriInOfficina from './LavoriInOfficina'

const VISTA_OFFICINA = 'officina'
const VISTA_SCHEDE = 'schede'

export default function SchedeLavoroBeta() {
  const [searchParams, setSearchParams] = useSearchParams()
  const canCreate = usePermission('work_orders.create')
  const canVedereInterventiAttivi = usePermission('interventi_attivi.view')

  const elenco = <SchedeLavoro detailPath="/schede-lavoro" showNewButton={canCreate} />

  // Senza il permesso la pagina resta esattamente quella di prima: nessun tab,
  // nessuna cornice in piu'. Uscendo di qui, `?vista=` non viene nemmeno letto.
  if (!canVedereInterventiAttivi) return elenco

  // Il tab attivo sta nell'URL, non in useState: aprendo una scheda questa
  // pagina si smonta, e tornando indietro si rimonta da capo. Con useState si
  // riapriva sempre "Schede lavoro", anche a chi era partito da qui.
  // Nessun parametro = tab schede lavoro, cosi' i link esistenti a
  // /schede-lavoro continuano ad aprirsi come prima.
  const vista = searchParams.get('vista') === VISTA_OFFICINA ? VISTA_OFFICINA : VISTA_SCHEDE

  const cambiaVista = (chiave: string) => {
    // Si parte da window.location.search, non dai searchParams di questo
    // render: l'URL vero e' gia' aggiornato (history.replaceState e' sincrono)
    // anche se una scrittura di filtro e' appena partita dalla lista. Cosi' il
    // cambio tab non cancella un filtro appena scelto.
    const next = new URLSearchParams(window.location.search)
    if (chiave === VISTA_OFFICINA) next.set('vista', VISTA_OFFICINA)
    else next.delete('vista')

    // I filtri della lista restano dove sono: sono il contesto a cui l'utente
    // torna cambiando tab, e la lista dietro resta montata a usarli.
    // `replace: true` come per i filtri: la voce di cronologia si aggiorna sul
    // posto, altrimenti ogni cambio tab ne aggiungerebbe una.
    setSearchParams(next, { replace: true })
  }

  return (
    <Tabs
      activeKey={vista}
      onChange={cambiaVista}
      items={[
        { key: VISTA_SCHEDE, label: 'Schede lavoro', children: elenco },
        { key: VISTA_OFFICINA, label: 'Lavori in officina', children: <LavoriInOfficina /> },
      ]}
    />
  )
}
